<template>
  <div class="pa-4 pa-md-6">
    <h2 class="font-weight-bold mb-3 mb-md-5">Summary Report</h2>

    <v-card class="shadow">
      <div class="d-flex justify-space-between align-center bs-py-3 bs-px-4">
        <div class="d-flex">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="secondary"
                v-bind="attrs"
                v-on="on"
                @click="loadItems"
              >
                <v-icon>mdi-cached</v-icon>
              </v-btn>
            </template>
            <span>Refresh</span>
          </v-tooltip>
        </div>
      </div>

      <v-divider></v-divider>

      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="records"
          :loading="loading"
          loading-text="Loading, please wait a moment"
          :items-per-page="itemsPerPage"
          :footer-props="{
            'items-per-page-options': itemsPerPageOptions,
            'disable-pagination': loading,
          }"
        >
          <template v-slot:[`item.bet_amount`]="{ item }">
            {{ formatPrice(item.bet_amount) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import formRules from "@/helpers/formRules";
import api from "@/utils/api";
import { mapActions } from "vuex";
import { formatPrice } from "@/utils/formatPrice";

export default {
  data: () => ({
    records: [],
    loading: true,
    search: "",
    itemsPerPage: 10,
    itemsPerPageOptions: [10, 25, 50, 100],
    rules: formRules,
    headers: [
      { text: "Year", value: "year", class: "text-uppercase" },
      {
        text: "Registered Players",
        value: "total_players",
        class: "text-uppercase",
      },
      { text: "Bet Count", value: "bet_count", class: "text-uppercase" },
      {
        text: "Bet Amount",
        value: "bet_amount",
        class: "text-uppercase",
      },
    ],
  }),

  mounted() {
    this.loadItems();
  },

  methods: {
    formatPrice,
    ...mapActions("logout", ["sendLogoutRequest"]),

    async loadItems() {
      this.loading = true;
      try {
        const { data } = await api.get("/summary_report");
        this.records = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
